// Karusan — scripts propios de la tienda
(function () {
  "use strict";

  function activarEntrada(el) {
    el.classList.add("mt-visible");
    if (!el.classList.contains("mt-reveal-stagger")) return;
    var hijos = el.children;
    var PASO_MS = 80;
    var DURACION_MS = 700;
    for (var i = 0; i < hijos.length; i++) {
      var hijo = hijos[i];
      var retraso = i * PASO_MS;
      hijo.style.transitionDelay = retraso + "ms";
      /* eslint-disable-next-line no-loop-func */
      (function (hijo, retraso) {
        setTimeout(function () {
          hijo.style.transitionDelay = "";
        }, retraso + DURACION_MS + 50);
      })(hijo, retraso);
    }
  }

  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal, .mt-reveal-stagger");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(activarEntrada);
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activarEntrada(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initFaq() {
    document.querySelectorAll(".mt-faq__lista").forEach(function (lista) {
      var items = lista.querySelectorAll(".mt-faq__item");
      items.forEach(function (item) {
        item.addEventListener("toggle", function () {
          if (item.open) {
            items.forEach(function (otro) {
              if (otro !== item) otro.removeAttribute("open");
            });
          }
        });
      });
    });
  }

  function initGaleria() {
    document.querySelectorAll("[data-mt-galeria]").forEach(function (galeria) {
      var principal = galeria.querySelector("[data-mt-galeria-principal]");
      var minis = galeria.querySelectorAll("[data-mt-galeria-mini]");
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener("click", function () {
          var src = mini.getAttribute("data-mt-galeria-mini");
          principal.querySelector("img").setAttribute("src", src);
          minis.forEach(function (m) { m.classList.remove("mt-activa"); });
          mini.classList.add("mt-activa");
        });
      });
    });
  }

  function initHeroTilt() {
    var wrap = document.querySelector("[data-mt-tilt]");
    if (!wrap) return;
    var img = wrap.querySelector("img");
    var hero = wrap.closest(".mt-hero");
    if (!hero || !img) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!window.matchMedia("(hover: hover)").matches) return;

    hero.addEventListener("mousemove", function (e) {
      var rect = hero.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      img.style.setProperty("--mt-tilt-x", (y * -12).toFixed(2) + "deg");
      img.style.setProperty("--mt-tilt-y", (x * 12).toFixed(2) + "deg");
    });
    hero.addEventListener("mouseleave", function () {
      img.style.setProperty("--mt-tilt-x", "0deg");
      img.style.setProperty("--mt-tilt-y", "0deg");
    });
  }

  function initComparador() {
    document.querySelectorAll("[data-mt-comparador]").forEach(function (caja) {
      var capaAntes = caja.querySelector("[data-mt-comparador-antes]");
      var linea = caja.querySelector("[data-mt-comparador-linea]");
      if (!capaAntes || !linea) return;

      function fijarPos(porcentaje) {
        var p = Math.max(0, Math.min(100, porcentaje));
        capaAntes.style.clipPath = "inset(0 " + (100 - p) + "% 0 0)";
        linea.style.left = p + "%";
        caja.setAttribute("aria-valuenow", Math.round(p));
      }

      function posDesdeEvento(clientX) {
        var rect = caja.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      var arrastrando = false;

      caja.addEventListener("mousemove", function (e) {
        caja.setAttribute("data-mt-interactuado", "");
        fijarPos(posDesdeEvento(e.clientX));
      });

      caja.addEventListener("pointerdown", function (e) {
        arrastrando = true;
        caja.setAttribute("data-mt-interactuado", "");
        caja.setPointerCapture(e.pointerId);
        fijarPos(posDesdeEvento(e.clientX));
      });
      caja.addEventListener("pointermove", function (e) {
        if (!arrastrando) return;
        fijarPos(posDesdeEvento(e.clientX));
      });
      caja.addEventListener("pointerup", function () { arrastrando = false; });
      caja.addEventListener("pointercancel", function () { arrastrando = false; });

      caja.addEventListener("keydown", function (e) {
        var actual = parseFloat(caja.getAttribute("aria-valuenow")) || 50;
        if (e.key === "ArrowLeft") { fijarPos(actual - 5); caja.setAttribute("data-mt-interactuado", ""); }
        if (e.key === "ArrowRight") { fijarPos(actual + 5); caja.setAttribute("data-mt-interactuado", ""); }
      });
    });
  }

  function initCifras() {
    var els = document.querySelectorAll("[data-mt-cifra]");
    if (!els.length) return;
    var animar = function (el) {
      var final = parseFloat(el.getAttribute("data-mt-cifra")) || 0;
      var duracion = 1400;
      var inicio = null;
      var sufijo = el.getAttribute("data-mt-sufijo") || "";
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = Math.floor(progreso * final);
        el.textContent = valor + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = final + sufijo;
      }
      requestAnimationFrame(paso);
    };
    if (!("IntersectionObserver" in window)) {
      els.forEach(animar);
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animar(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initProductoVariantes() {
    var form = document.querySelector("#mt-producto-form");
    if (!form) return;
    var dataEl = document.querySelector("[data-mt-producto-variantes]");
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var inputId = form.querySelector('input[name="id"]');
    var botonesOpciones = form.querySelectorAll("[data-mt-opcion-valor]");
    var precioActual = document.querySelector("[data-mt-precio-actual]");
    var precioAntes = document.querySelector("[data-mt-precio-antes]");
    var botonComprar = form.querySelector("[data-mt-comprar]");
    var textoAgotado = document.querySelector("[data-mt-agotado]");

    var seleccion = {};
    botonesOpciones.forEach(function (btn) {
      if (btn.classList.contains("mt-activa")) {
        seleccion[btn.getAttribute("data-mt-opcion-nombre")] = btn.getAttribute("data-mt-opcion-valor");
      }
    });

    function formatMoney(centavos) {
      return "$" + (centavos / 100).toFixed(2);
    }

    function actualizar() {
      var encontrada = variantes.find(function (v) {
        return v.opciones.every(function (o) { return seleccion[o.nombre] === o.valor; });
      });
      if (!encontrada) return;
      if (inputId) inputId.value = encontrada.id;
      if (precioActual) precioActual.textContent = formatMoney(encontrada.precio);
      if (precioAntes) {
        if (encontrada.precioAntes && encontrada.precioAntes > encontrada.precio) {
          precioAntes.textContent = formatMoney(encontrada.precioAntes);
          precioAntes.style.display = "";
        } else {
          precioAntes.style.display = "none";
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !encontrada.disponible;
        botonComprar.querySelector("[data-mt-comprar-texto]").textContent = encontrada.disponible
          ? botonComprar.getAttribute("data-mt-texto-disponible")
          : botonComprar.getAttribute("data-mt-texto-agotado");
      }
      if (textoAgotado) textoAgotado.style.display = encontrada.disponible ? "none" : "";
    }

    botonesOpciones.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var nombre = btn.getAttribute("data-mt-opcion-nombre");
        form.querySelectorAll('[data-mt-opcion-nombre="' + CSS.escape(nombre) + '"]').forEach(function (b) {
          b.classList.remove("mt-activa");
        });
        btn.classList.add("mt-activa");
        seleccion[nombre] = btn.getAttribute("data-mt-opcion-valor");
        actualizar();
      });
    });

    var cantidadInput = form.querySelector("[data-mt-cantidad-input]");
    form.querySelectorAll("[data-mt-cantidad-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!cantidadInput) return;
        var actual = parseInt(cantidadInput.value, 10) || 1;
        var delta = btn.getAttribute("data-mt-cantidad-btn") === "mas" ? 1 : -1;
        cantidadInput.value = Math.max(1, actual + delta);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initFaq();
    initGaleria();
    initHeroTilt();
    initComparador();
    initCifras();
    initProductoVariantes();
  });
})();
